import SetTokenAction from './actions/SetTokenAction'
import ShowViewAction from './actions/ShowViewAction'
import ShowJobProgressAction from './actions/ShowJobProgressAction'

const actionMap = new Map()
actionMap.set('set_token', SetTokenAction)
actionMap.set('show_view', ShowViewAction)
actionMap.set('show_job_progress', ShowJobProgressAction)

export default class ActionHandler {
  static run (jsonActions) {
    if (!jsonActions) {
      return []
    }

    if (!Array.isArray(jsonActions)) {
      jsonActions = [jsonActions]
    }

    return jsonActions.map(json => {
      const ActionClass = actionMap.get(json.type)

      if (!ActionClass) {
        console.warn(`Action Handler Class for [${json.type}] not found`)

        return undefined
      }

      return (new ActionClass(json)).handle()
    })
  }
}
